
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gmByaDwbx4I9r_mG_45fB7kh_R_45nUdMOxV_45KPbd9Apaw8oMeta } from "/codebuild/output/src136501229/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexLnAC88ATAF43Sf9Io2gzcZN4DnBC4USMoguNpclD5RoMeta } from "/codebuild/output/src136501229/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchTRxuZbztFzPlz_453JVtQbqGVTA46w8ARxFtp97DB1IsAMeta } from "/codebuild/output/src136501229/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexxwXSBdHkjysfLxeb3I_Sjw7N1AVFxclggg_IkPaHtEcMeta } from "/codebuild/output/src136501229/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93701xJxBioTVkXK8edJvnPhscqYDRDDynLuyxAgatB2AMeta } from "/codebuild/output/src136501229/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index_45dJozaMYVDYPacHcrctRk40rJjXH7e7Siq3oRPiBgwMMeta } from "/codebuild/output/src136501229/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93wEQRPOpxWtY1civCfyvE7gRB_f_VDvnFXFsRdbHY_45DUMeta } from "/codebuild/output/src136501229/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index2MgYYGY1_45YSXvvY2q5tiP1N2G7gp1M8DhjX_45PursKooMeta } from "/codebuild/output/src136501229/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93zXBij4VCddEUtr3kOqyyX4RAnnWknArUfsYhCWqoJBMMeta } from "/codebuild/output/src136501229/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexhiP9G0WORiDFTu2GbdLfV0tlipkf45Lt37jF9f0WnuIMeta } from "/codebuild/output/src136501229/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexj4SsGo9FbaN4LlEa9jCYl6vkCr6htdqC9HnhLN_45yzUcMeta } from "/codebuild/output/src136501229/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src136501229/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src136501229/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src136501229/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src136501229/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src136501229/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index_45dJozaMYVDYPacHcrctRk40rJjXH7e7Siq3oRPiBgwMMeta || {},
    component: () => import("/codebuild/output/src136501229/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src136501229/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index2MgYYGY1_45YSXvvY2q5tiP1N2G7gp1M8DhjX_45PursKooMeta || {},
    component: () => import("/codebuild/output/src136501229/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src136501229/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexhiP9G0WORiDFTu2GbdLfV0tlipkf45Lt37jF9f0WnuIMeta || {},
    component: () => import("/codebuild/output/src136501229/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexj4SsGo9FbaN4LlEa9jCYl6vkCr6htdqC9HnhLN_45yzUcMeta || {},
    component: () => import("/codebuild/output/src136501229/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]